import { useCallback, useEffect, useState } from 'react';

/**
 * Tracks and toggles browser fullscreen for the document root element.
 */
export function useFullscreen(): { isFullscreen: boolean; toggleFullscreen: () => void } {
  const [isFullscreen, setIsFullscreen] = useState(
    () => typeof document !== 'undefined' && document.fullscreenElement !== null,
  );

  useEffect(() => {
    function handleFullscreenChange() {
      setIsFullscreen(document.fullscreenElement !== null);
    }

    document.addEventListener('fullscreenchange', handleFullscreenChange);
    return () => document.removeEventListener('fullscreenchange', handleFullscreenChange);
  }, []);

  const toggleFullscreen = useCallback(() => {
    void (async () => {
      try {
        if (document.fullscreenElement) {
          await document.exitFullscreen();
          return;
        }

        await document.documentElement.requestFullscreen();
      } catch {
        // Browser may reject fullscreen without a user gesture or policy.
      }
    })();
  }, []);

  return { isFullscreen, toggleFullscreen };
}
